import { apiRequest, withToken } from './http-client';

export const createTicket = async (token, data) => {
    return apiRequest({
        method: 'post',
        url: '/ticket/',
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getTickets = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/ticket/',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const searchTickets = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/ticket/search',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const searchTicketAssignees = async (token, params = {}) => {
    return apiRequest({
        method: 'get',
        url: '/ticket/assignees/search',
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const getTicketById = async (token, ticketId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/ticket/${ticketId}`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const updateTicket = async (token, ticketId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/ticket/${ticketId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const bulkStatusFollowUpdate = async (token, data) => {
    return apiRequest({
        method: 'post',
        url: '/ticket/bulk-status-follow',
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getTicketFollows = async (token, ticketId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/ticket-follow/${ticketId}`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const createTicketFollow = async (token, ticketId, data) => {
    return apiRequest({
        method: 'post',
        url: `/ticket-follow/${ticketId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const deleteTicket = async (token, ticketId) => {
    return apiRequest({
        method: 'delete',
        url: `/ticket/${ticketId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const getTicketCategories = async (token, projectId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/ticket-category`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const createTicketCategory = async (token, projectId, data) => {
    return apiRequest({
        method: 'post',
        url: `/project/${projectId}/ticket-category`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const deleteTicketCategory = async (token, projectId, categoryId) => {
    return apiRequest({
        method: 'delete',
        url: `/project/${projectId}/ticket-category/${categoryId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateTicketCategory = async (token, projectId, categoryId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/ticket-category/${categoryId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const getTicketSubcategories = async (token, projectId, params = {}) => {
    return apiRequest({
        method: 'get',
        url: `/project/${projectId}/ticket-subcategory`,
        headers: withToken(token),
        params,
    }, 'No se pudo validar la sesión');
};

export const createTicketSubcategory = async (token, projectId, data) => {
    return apiRequest({
        method: 'post',
        url: `/project/${projectId}/ticket-subcategory`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};

export const deleteTicketSubcategory = async (token, projectId, subcategoryId) => {
    return apiRequest({
        method: 'delete',
        url: `/project/${projectId}/ticket-subcategory/${subcategoryId}`,
        headers: withToken(token),
    }, 'No se pudo validar la sesión');
};

export const updateTicketSubcategory = async (token, projectId, subcategoryId, data) => {
    return apiRequest({
        method: 'patch',
        url: `/project/${projectId}/ticket-subcategory/${subcategoryId}`,
        headers: withToken(token),
        data,
    }, 'No se pudo validar la sesión');
};